// extracted by mini-css-extract-plugin
module.exports = {"footer-links":"Footer_footer-links__1vO8Z"};